import React, { FC, useEffect } from 'react';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { StoreNameRoot } from '../features/storeName';
import { useMsId, useSelectedCategory, useHasMetasiteError } from '../store/appStore';
import { SelectThemeFirst } from '../experiments';
import { useSpec } from '../hooks/useSpec';
import { DsBuilderMethod } from '../types';

export const StoreName: FC = () => {
  const metasiteError = useHasMetasiteError();
  const biLogger = useBiLogger();
  const msId = useMsId();
  const currentCategoryValue = useSelectedCategory();
  const shouldSelectThemeFirst = useSpec(SelectThemeFirst);

  useEffect(() => {
    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.STORE_NAME]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if ((!shouldSelectThemeFirst && !msId) || !currentCategoryValue) {
    return;
  }

  if (metasiteError) {
    return <GeneralError />;
  }

  return <StoreNameRoot />;
};
